import React from 'react'
import { Helmet } from 'react-helmet-async'
import { UrlEndpointFunctionVersionLayout } from '../../layouts/Settings'

const UrlEndpointFunctionVersionPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>URL Endpoint Function Version</title>
      <meta name="description" content="URL Endpoint Function Version page" />
    </Helmet>
    <UrlEndpointFunctionVersionLayout />
  </React.Fragment>
)

export default UrlEndpointFunctionVersionPage